import { FC } from 'react';
import { TitleRow } from 'components/TitleRow';
import { CustomerTaxeItem } from 'ui/CustomerTaxeItem';
import styles from './TaxesList.module.scss';
import { UseInfiniteScrollHookRefCallback } from 'react-infinite-scroll-hook';
import { TaxesItemsTypes } from 'redux/Api/taxesApi/type';
interface TaxesListTypes {
  taxesList: TaxesItemsTypes[];
  intersectionRef?: UseInfiniteScrollHookRefCallback;
}

export const TaxesList: FC<TaxesListTypes> = ({ taxesList, intersectionRef }) => {
  const dataTitle = [
    'ID',
    'Исполнитель',
    'Сумма в копилке, ₽',
    'Сумма к оплате, ₽',
    'Оплачено, ₽',
    'Сумма к возврату, ₽',
    'Возвращено, ₽',
    'Сумма в квитанции, ₽',
  ];

  return (
    <div className={styles.root}>
      <TitleRow data={dataTitle} title={'taxesWorkSupport'} />
      {taxesList ? (
        taxesList.map((elem: TaxesItemsTypes, index) => {
          const triggerIndex = Math.max(0, taxesList.length - 15);
          const shouldAttachRef = index === triggerIndex;

          return (
            // <Link key={elem.worker_id ref={shouldAttachRef ? intersectionRef : undefined}} to={`/taxes/${elem.worker_id}`}>
            <div key={elem.worker_id} ref={shouldAttachRef ? intersectionRef : undefined}>
              <CustomerTaxeItem taxe={elem} />
            </div>
            // </Link>
          );
        })
      ) : (
        <div className={styles.root_nothing}>
          <p>Ничего не найдено</p>
        </div>
      )}
    </div>
  );
};
